module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/EllipsisWhite-8e05bf8f54a728483fee626dadc04c4e.png";